export default __webpack_public_path__ + "static/media/2.f72c0cad.jpg";